export default __webpack_public_path__ + "static/media/logo_DESKTOP.a7907dd4.svg";